import request from 'admin-ng/util/request-promise';
import {DOCUMENTS} from '.';

export const all = params => request(DOCUMENTS, 'get', params);
export const one = id => request(`${DOCUMENTS}${id}`, 'get');
export const create = params => request(DOCUMENTS, 'post', params);
export const update = (id, params) =>
  request(`${DOCUMENTS}${id}`, 'put', params);
